import DragAndDropGroup from "@/components/Elements/DragAndDropGroup";

import Group from "./Group";

const MovableGroups = ({
  schema,
  onGroupRename,
  onGroupCopy,
  onDeleteGroup,
}) => {
  return schema?.groups?.map((group) => {
    return (
      <DragAndDropGroup.Sortable
        id={group.legend}
        key={`movable-group-${group.legend}`}
      >
        <Group.Preview
          onGroupRename={group.readonly ? undefined : onGroupRename}
          onGroupCopy={group.unclonable ? undefined : onGroupCopy}
          dnd
          legend={group.legend}
          onDeleteGroup={onDeleteGroup}
        />
      </DragAndDropGroup.Sortable>
    );
  });
};

export default MovableGroups;
